/*
 * Module for the scheduled status modal, where a status change can be scheduled or canceled
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicScheduledStatusModal/topicScheduledStatusModalView",
  "moment",
  "modules/topicsSplit/topic/topicPublishModal/topicPublishModalModule",
  "modules/topicsSplit/topic/topicDisableModal/topicDisableModalModule",
  "modules/header/kbMenu/kbMenuModel",
  "modules/topicsSplit/topic/topicEnableModal/topicEnableModalModule",
], function (
  Marionette,
  $,
  Messenger,
  TopicScheduledStatusModalView,
  Moment,
  TopicPublishModalModule,
  TopicDisableModalModule,
  KbMenuModel,
  TopicEnableModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicScheduledStatusModal";
      this.region = options.region;
    },
    show: function (options) {
      this.scheduledStatus = options.scheduledStatus;
      this.currentStatusId = options.currentStatusId;
      this.topic = options.topic;
      this.statuses = Messenger.reqres.request("kb:statuses");
      this._setStatusOptions();
      this.view = new TopicScheduledStatusModalView.topicScheduledStatusModalView({
        model: this.scheduledStatus,
      });
      this.view.on(
        "delete:status",
        function () {
          Messenger.yesNoDialog(
            "topic.scheduledStatus.deleteDialog",
            {
              yes: () => {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Topic Scheduled Status",
                  id: this.topic.id,
                  idType: "Topic",
                  object: "Topic Scheduled Status",
                });
                //only need to fire an actual delete if the model is unchanged (otherwise, we added a scheduled
                // status and deleted it before saving)
                const needToDelete = !this.scheduledStatus.dirty;
                if (needToDelete) {
                  this.scheduledStatus.deleteModel();
                }
                //reset model using custom function to set the attributes back to their defaults
                this.scheduledStatus.reset();
              },
            },
            this,
          );
        },
        this,
      );
      this.view.on(
        "schedule",
        function () {
          this._updateStatusModel(); //returns false if there was missing or invalid data
        },
        this,
      );
      this.view.on(
        "done",
        function () {
          this.scheduledStatus.saveModel();
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.showRegion(this.view);
    },
    statusError: function (errorMessage) {
      this.view.statusError(errorMessage);
    },
    _setStatusOptions: function () {
      this.scheduledStatus.transitions = null;
      this.scheduledStatus.statusArray = null;
      Messenger.reqres.request("topic:statuses", this.topic).then((transitions) => {
        this.scheduledStatus.transitions = transitions;
        //also get the statuses and add it to the scheduledStatus object
        this.scheduledStatus.statusArray = this.statuses.get("allTopicStatuses");
        this.view.render();
      });
    },
    _updateStatusModel: function () {
      //get new status and timestamp and check if date is valid (status is always valid)
      const status = this.view.getStatus();
      const date = this.view.getChangeDate();
      const statusText = this.view.getStatusText();
      console.log("date: " + date);
      if (!date) {
        this.statusError($.t("topic.scheduledStatus.emptyDateError"));
        return false;
      }
      const now = new Date();
      if (date < now) {
        this.statusError($.t("topic.scheduledStatus.dateTimeInPastError"));
        return false;
      }
      const topic = this.topic;
      this.scheduledStatus.set("statusId", status);
      this.scheduledStatus.set("statusTimestamp", date);
      this.scheduledStatus.set("responseTemplateIds", null);
      if (statusText == $.t("topic.statuses.publishSelected")) {
        Messenger.vent.trigger(
          "show:modal",
          TopicPublishModalModule,
          {
            namespace: "topicScheduleStatus",
          },
          topic,
          {
            title: "topic.publish.title",
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Topic Schedule Publish Selected",
              id: topic.id,
              idType: "Topic",
              object: "Topic",
            },
          },
        );
      } else if (statusText == $.t("topic.statuses.disableSelected")) {
        Messenger.vent.trigger(
          "show:modal",
          TopicDisableModalModule,
          {
            namespace: "topicScheduleStatus",
          },
          topic,
          {
            title: "topic.disable.title",
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Topic Schedule Disable Selected",
              id: topic.id,
              idType: "Topic",
              object: "Topic",
            },
          },
        );
      } else if (statusText == $.t("topic.statuses.enableSelected")) {
        Messenger.vent.trigger(
          "show:modal",
          TopicEnableModalModule,
          {
            namespace: "topicScheduleStatus",
          },
          topic,
          {
            title: "topic.enable.title",
            closeOnBackgroundClick: false,
            modalWidth: 550,
            trackInteraction: {
              action: "Topic Schedule Enable Selected",
              id: topic.id,
              idType: "Topic",
              object: "Topic",
            },
          },
        );
      } else {
        Messenger.save((success) => {
          if (success) {
            const topic = this.topic;
            topic.scheduledStatus().set("responseTemplateIds", null);
          }
        });
      }
      return true;
    },
  });
});
